import "./header.scss";
import { Box } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "assets/images/logo.svg";

import UserHeader from "./UserHeader";
import LoggedOutLinks from "./LoggedOutLinks";
import { useSelector } from "react-redux";
import { runWithGameLeaveGuard } from "Pages/Games/gameLeaveGuardRegistry";

const Header = ({ drawerWidth, user: _user }) => {
  const navigate = useNavigate();
  const { isAuthenticated: reduxAuth, isLoading: isAuthLoading } = useSelector(
    (state) => state?.auth || {},
  );
  const isAuthenticated = Boolean(!isAuthLoading && reduxAuth);

  const [isScrolled, setIsScrolled] = useState(false);

  const guardedNavigate = useCallback(
    (to, options) => {
      runWithGameLeaveGuard(() => navigate(to, options));
    },
    [navigate],
  );

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 8);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleLogoClick = () => {
    if (isAuthenticated) {
      guardedNavigate("/lists");
    } else {
      guardedNavigate("/");
    }
  };

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        boxSizing: "border-box",
        zIndex: 1200,
        backgroundColor: "#ffffff",
        boxShadow: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: "3.5rem",
        padding: { xs: "0 0.75rem", md: "0 1.5rem" },
      }}
      className={`header-box mui-fixed${
        isScrolled ? " header-box--scrolled" : ""
      }`}
    >
      <Box
        className="header-title-btn"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: { xs: "0.5rem", md: "0.75rem" },
        }}
      >
        <img
          src={Logo}
          onClick={handleLogoClick}
          alt="Logo"
          className="logo-image"
          loading="lazy"
          style={{ cursor: "pointer" }}
        />
      </Box>
      {isAuthenticated ? (
        <UserHeader drawerWidth={drawerWidth} />
      ) : (
        <LoggedOutLinks />
      )}
    </Box>
  );
};

export default memo(Header);
